import React from "react";
import MediaGallery from "./MediaGallery"

import classes from "./ProjectExpandedView.module.css";

function ProjectExpandedView({ project }) {
    return (
        <div className={classes.expandedView}>
            {(project.screenshotPath || project.widget) &&
                <div className={classes.topSection}>
                    <div className={classes.mediaGallery}>
                        <MediaGallery folderPath={project.screenshotPath} />
                    </div>
                    <div className={classes.steamWidget}>
                        {project.widget}
                    </div>
                </div>
            }
            <div className={classes.description}>
                {project.description}
            </div>
        </div>
    );
}

export default ProjectExpandedView;